<script setup>
import { DialogRoot } from 'radix-vue'

const props = defineProps({
  open: { type: Boolean, default: undefined }
})
const emits = defineEmits(['update:open'])
</script>

<template>
  <DialogRoot
    :open="props.open"
    @update:open="emits('update:open', $event)"
  >
    <slot />
  </DialogRoot>
</template>
